import { FC } from 'react';
import { Section } from './ui/Section';
import { EntryBlock } from './ui/EntryBlock';
import type { Entry } from '../types/cv';

interface Props {
  certificates: Entry[];
  title?: string;
  oneLine?: boolean;
}

export const Certificates: FC<Props> = ({
  certificates,
  title = 'Certificates',
  oneLine = false,
}) => (
  <Section title={title}>
    {certificates.map((cert, i) => (
      <EntryBlock
        key={`${cert.name}-${i}`}
        entry={cert}
        title={cert.name}
        role={cert.issuer && <span className="cv-sub">{cert.issuer}</span>}
        oneLine={oneLine}
      />
    ))}
  </Section>
);

export default Certificates;
